import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DsCoinBadge from '../ds/molecules/CoinBadge';
import '../../static/images/coin.png';
import Btn from '../ds/atoms/btn/base';
import { IconComponent } from '../ds/atoms/icons/iconComponent';

class UserDataTab extends Component {
  constructor(props) {
    super(props);
    this.state = { isVisible: false };
  }

  togglePayment = () => {
    this.setState((prevState) => ({
      isVisible: !prevState.isVisible,
    }));
  };

  loyaltyTextColor = (txtColor) => {
    if (txtColor.includes('Gold')) {
      return 'text-loyalty-gold';
    } if (txtColor.includes('Black')) {
      return 'text-loyalty-black';
    } if (txtColor.includes('Platinum')) {
      return 'text-loyalty-platinum';
    } if (txtColor.includes('Silver')) {
      return 'text-loyalty-platinum';
    }
    return 'text-loyalty-blue';
  }

  onClick(redirectTo, userData) {
    const { jwt_token } = userData;
    const url = `${process.env.SANDOS4U_SITE}?member_token=${jwt_token}&redirectTo=${redirectTo}`;
    window.open(url, '_blank');
  }

  renderListPayment(label, unit, isGrid = false) {
    const styleClass = isGrid ? 'grid grid-cols-1 justify-items-stretch' : 'flex justify-between';
    const styleUnit = isGrid ? 'ml-5' : '';
    return (
            <li className="capitalize my-1">
              <div className={styleClass}>
                <div>
                  <IconComponent icon='check' className="mr-2 text-status-green flex-shrink-0 mt-0.5"/>
                  {label}:
                </div>
                <div className={styleUnit}>{unit}</div>
              </div>
            </li>
    );
  }

  renderPayment() {
    const paidAmount = this.props.booking.amount_payments;
    const discountApplied = this.props.usedCoins.discount_applied || 0;
    const pendingAmount = this.props.usedCoins.pending_amount;
    const paymentMethods = this.props.booking.hotel.payment_methods;
    const paymentExternalMethod = this.props.booking.payment_external_method || 'ATHOTEL';
    const paymentMethod = paymentMethods.filter((el) => el.code === paymentExternalMethod)[0];
    const coinsUsed = this.props.usedCoins.coins_used;
    const currency = `${this.props.booking.paid_currency.symbol} (${this.props.booking.paid_currency.code})`;
    return (
            <ul className="text-primary">
              {this.renderListPayment(this.context.t('Paid amount (with payment method)'), `${paidAmount} ${currency}`)}
              {this.renderListPayment(this.context.t('Paid amount with Loyalty coins'), `${discountApplied} ${currency}`)}
              {this.renderListPayment(this.context.t('Paid amount of Loyalty Coins used'), `${discountApplied} ${currency}`)}
              {this.renderListPayment(this.context.t('Pending amount to pay in hotel'), `${pendingAmount} ${currency}`)}
              {this.renderListPayment(this.context.t('Payment method'), paymentMethod ? paymentMethod.name
                : null, true)}
              {this.renderListPayment(this.context.t('Loyalty coins used'), coinsUsed)}
              {this.renderListPayment(
                this.context.t('When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).', {
                  chain: this.props.chainData.loyalty_name.toUpperCase(),
                }))}
            </ul>
    );
  }

  render() {
    let userCoins = this.props.usedCoins.coins_before_booking - this.props.usedCoins.coins_used;
    if (this.props.new_member && this.props.new_member_discount_percentage_activated) {
      userCoins = 0;
    }

    return (

<div className="mb-20">
<div className="grid grid-cols-1 sm:grid-cols-4 gap-4 text-center sm:text-left my-5">
<div className="">
<img className="avatar-image" src= {
  this

    .props

    .userData

    .profile_picture
}

/>
<div className="mt-2 text-left">
  <p className="font-bold text-base">{this.props.userData.first_name}</p>
  <p>{this.props.userData.card_code}</p>
</div>
</div>
<div className="-mx-1 col-span-2">
  <div className="grid grid-cols-1 gap-1 justify-items-start">
    <div>
      <Btn variant='link'
           onClick={() => this.onClick('/dashboard', this.props.userData)}>{this.context.t('my area')}</Btn>
    </div>
    <div>
      <Btn variant='link'
           onClick={() => this.onClick('/catalogue', this.props.userData)}>{this.context.t('catalogue')}</Btn>
    </div>
    <div>
      <Btn variant='link'
           onClick={() => this.onClick('/#how-it-works', this.props.userData)}>{this.context.t('how it works')}</Btn>
    </div>
    <div>
      <Btn variant='link' onClick={() => this.togglePayment()}>{this.context.t('payment concepts')}</Btn>
    </div>
  </div>
</div>
<div className="">
  <DsCoinBadge
          lang={this.props.lang}
          coins={this.props.coins}
          className="py-2"
          loyalty={this.props.loyalty}
  >
    {this.context.t('When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).', {
      chain: this.props.chainData.loyalty_name.toUpperCase(),
    })}
  </DsCoinBadge>
</div>
</div>
<div className="grid grid-cols-1 sm:grid-cols-4 gap-4 my-5">
  <div className="col-span-1 pt-8">
    <div className="card-level-box w-full ml-2">
      <small className="text-gray-link font-semibold uppercase">{this.context.t('Your Level')}</small>
      <h3>{this.props.loyalty.loyalty_name}
        <span
                className={`font-semibold uppercase ${this.loyaltyTextColor(this.props.userData.membership_name)}`}
        >
                  {this.props.userData.membership_name}
                </span>
      </h3>
    </div>
  </div>
  <div className="col-span-2 mr-8">
    <div className={`card-level-box w-full ml-2 sm:ml-0 ${this.state.isVisible ? '' : 'hidden'}`}>
      {this.renderPayment()}
    </div>
  </div>
  <div className="col-span-1">
    <p className="uppercase text-blue-500 font-bold">{this.context.t('Your wallet')}</p>
    <img className="float-left" src="/img/coin.png"/>
    <p className="mt-5"><span className="font-bold text-lg">{userCoins}</span> coins</p>
  </div>
</div>
</div>
    );
  }
}

UserDataTab.propTypes = {
  loyalty: PropTypes.object.isRequired,
  coins:
  PropTypes.number.isRequired,
  lang:
  PropTypes.string.isRequired,
  usedCoins:
  PropTypes.object.isRequired,
  booking:
  PropTypes.object.isRequired,
};
UserDataTab.contextTypes = {
  t: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => (
  {
    userData: state.loyalty.loggedUser,
    chainData: state.session.chainData,
    new_member: state.loyalty.newMember,
    new_member_discount_percentage_activated: state.booking.hotel != null
      ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  }
);

export default connect(mapStateToProps)(UserDataTab);
